window.addEventListener('load', () => {
  try {
    const marqueeElement = document.querySelector('.achievements');
    const marqueeGroup = marqueeElement ? marqueeElement.closest('.group') : null;
    const firstItemList = marqueeElement ? marqueeElement.firstElementChild : null;

    if (marqueeElement && firstItemList && marqueeGroup) {
      const scrollWidth = firstItemList.scrollWidth;
      const animationName = 'achievements-dynamic-scroll';

      const keyframes = `
          @keyframes ${animationName} {
            0% { transform: translateX(0); }
            100% { transform: translateX(-${scrollWidth}px); }
          }
        `;

      const style = document.createElement('style');
      style.innerHTML = keyframes;
      document.head.appendChild(style);

      marqueeElement.style.animationName = animationName;
      marqueeElement.style.animationDuration = '30s';
      marqueeElement.style.animationTimingFunction = 'linear';
      marqueeElement.style.animationIterationCount = 'infinite';
      marqueeElement.style.animationPlayState = 'running';

      marqueeGroup.addEventListener('mouseenter', () => {
        marqueeElement.style.animationPlayState = 'paused';
      });
      marqueeGroup.addEventListener('mouseleave', () => {
        marqueeElement.style.animationPlayState = 'running';
      });
    } else {
      console.error(
        'Could not find all required marquee elements (marquee, firstItemList, or group).',
      );
    }
  } catch (error) {
    console.error('Error initializing marquee:', error);
  }
});
